var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-radio',_vm._g(_vm._b({staticClass:"custom-radio",attrs:{"value":_vm.selectValue},model:{value:(_vm.localModel),callback:function ($$v) {_vm.localModel=$$v},expression:"localModel"}},'b-form-radio',_vm.$attrs,false),_vm.mountEventListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }